import React from 'react';
import { LegalPage } from './LegalPages';
import { contactInfo } from '../mock';
import { useLang } from '../context/LanguageContext';

export default function PrivacyPolicy() {
  const { lang } = useLang();
  return (
    <LegalPage title={lang === 'en' ? 'Privacy Policy' : 'गोपनीयता नीति'} subtitle={lang === 'en' ? 'Your data, your trust — fully protected' : 'आपका डेटा, आपका भरोसा'}>
      <p>
        Navavidha Bhakti (“we”, “us”, or “our”) operates the website
        <b> {contactInfo.domain} </b> and related devotional services. This Privacy Policy explains
        how we collect, use, disclose, and safeguard your information when you visit our website
        or book a puja with us.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li><b>Personal Information:</b> Full name, gotra, phone number, email address, and
          shipping address (for Prasad delivery) which you voluntarily provide when booking a puja.</li>
        <li><b>Payment Information:</b> Payment is processed by our PCI-DSS compliant partner
          Razorpay. We do NOT store your card, UPI PIN, or netbanking credentials on our servers.
          We only receive a payment reference ID and transaction status.</li>
        <li><b>Technical Information:</b> Browser type, IP address, device information, pages
          visited, and cookies for analytics and improving the experience.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To perform the puja in your name and gotra as per Sankalp.</li>
        <li>To send you the recorded puja video, sankalp timing and prasad shipment updates.</li>
        <li>To deliver Prasad and other physical items to your shipping address.</li>
        <li>To respond to your queries, provide customer support and process refunds.</li>
        <li>To send occasional updates about upcoming pujas (only if you opt-in via WhatsApp subscribe).</li>
        <li>To detect, prevent and address technical issues or fraud.</li>
      </ul>

      <h2>3. Sharing of Information</h2>
      <p>We do not sell, trade, or rent your personal information. We share limited information only with:</p>
      <ul>
        <li><b>Pandit Jis</b> assigned to your puja (name and gotra for Sankalp only).</li>
        <li><b>Payment Gateway (Razorpay):</b> transaction details for processing your payment.</li>
        <li><b>Shipping Partners:</b> name, phone, address for delivering Prasad.</li>
        <li><b>Legal Authorities:</b> when required by applicable law or a valid court order.</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We use industry-standard security measures including HTTPS/SSL encryption, secure
        password hashing, and access controls. Payment transactions are handled entirely
        by Razorpay over a PCI-DSS Level 1 certified environment.
      </p>

      <h2>5. Cookies</h2>
      <p>
        We use minimal cookies for essential functionality (session, language preference) and
        anonymous analytics. You can disable cookies from your browser settings, though some
        features may not work as expected.
      </p>

      <h2>6. Your Rights</h2>
      <ul>
        <li>Right to <b>access</b> the personal data we hold about you.</li>
        <li>Right to <b>correct</b> inaccurate data.</li>
        <li>Right to <b>delete</b> your account and associated data (email us to request).</li>
        <li>Right to <b>opt-out</b> of marketing WhatsApp / email messages at any time.</li>
      </ul>

      <h2>7. Children’s Privacy</h2>
      <p>
        Our services are intended for users aged 18 and above. We do not knowingly collect
        data from minors. If you believe a child has provided us information, please contact us
        and we will delete it promptly.
      </p>

      <h2>8. Changes to this Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes will be posted on this
        page with an updated “Last updated” date. Continued use of our services after changes
        constitutes acceptance of the revised policy.
      </p>

      <h2>9. Grievance Officer</h2>
      <p>
        For any privacy concerns, please contact our Grievance Officer at
        <a href={`mailto:${contactInfo.email}`}> {contactInfo.email}</a> or
        <a href={`tel:${contactInfo.phone}`}> {contactInfo.phone}</a>. We will respond within 7 working days.
      </p>
    </LegalPage>
  );
}
